/**
 * Created by Reda on 12.07.2024
 */

const StickersShopWindow = Prefab.createWindow("stickers_shop", "stickers_shop_window_prefab_json");
